import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const signInFormStyles = makeStyles((theme: Theme) =>
    createStyles({
        form: {
            width: "100%",
            maxWidth: 330,
            display: "flex",
            flexDirection: "column",
        },

        firstInputMargin: {
            marginBottom: 30,
        },

        secondInputMargin: {
            marginBottom: 4,
        },

        forgotPassword: {
            alignSelf: "end",
            marginBottom: 31,
        },

        signInButton: {
            marginBottom: 12,
        },

        rememberBe: {
            alignSelf: "start",
        },

        errorLabel: {
            color: theme.colors.feedback.error,
            marginBottom: 8,
        },
    })
);
